import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProfitlistPage } from './profitlist';

@NgModule({
  declarations: [
    ProfitlistPage,
  ],
  imports: [
    IonicPageModule.forChild(ProfitlistPage),
  ],
})
export class ProfitlistPageModule {}



// WEBPACK FOOTER //
// ./src/pages/profitlist/profitlist.module.ts